<template>
  <div class="why-crm">
    <div class="why-main">
      <img src="@/assets/v1/dot-bg.png" alt="" class="why-bg" />
      <div class="top-content">
        <div class="base-title">
          <div class="btitle">为什么选择睿泽</div>
          <div class="stitle" style="margin-bottom: 0px">
            睿泽是目前国内开源领域的开拓者，九年以来一直以用户需求为核心持续迭代更新。目前已达<br />
            到千万级的用户量，产品下载量突破百万次。
          </div>
        </div>
        <div class="why-wrap">
          <div class="why-wrap-item">
            <div><i class="num">10</i>大平台</div>
            <div class="why-desc">
              客户管理/人资管理/财务管理等<br />
              满足企业管理需求
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">150+</i>应用</div>
            <div class="why-desc">
              全方位的帮助您的企业<br />
              实现信息化管理
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">∞</i>人数</div>
            <div class="why-desc">
              无穷人数<br />
              不限制用户数量
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">0</i>费用</div>
            <div class="why-desc">
              客户管理<br />
              永久免费使用
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">12</i>语言</div>
            <div class="why-desc">
              英语/日语/韩语等<br />
              充分满足企业跨国协同需求
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">100+</i>行业</div>
            <div class="why-desc">
              多种行业解决方案<br />
              尽在掌握
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">9</i>年</div>
            <div class="why-desc">
              九年产品<br />
              持续迭代升级
            </div>
          </div>
          <div class="why-wrap-item">
            <div><i class="num">100</i>万</div>
            <div class="why-desc">
              100万+下载量<br />
              见证品质
            </div>
          </div>
          <!-- 浮动内容 -->
          <div class="modal-wrap">
            <div class="modal-item">
              <img src="@/assets/v1/group1.png" alt="" class="modal-pic" />
              <div class="modal-desc">高新技术企业</div>
            </div>
            <div class="modal-item">
              <img src="@/assets/v1/group2.png" alt="" class="modal-pic" />
              <div class="modal-desc">软件产品证书</div>
            </div>
            <div class="modal-item">
              <img src="@/assets/v1/group3.png" alt="" class="modal-pic" />
              <div class="modal-desc">计算机软件著作权</div>
            </div>
            <div class="modal-item">
              <img src="@/assets/v1/group4.png" alt="" class="modal-pic" />
              <div class="modal-desc">ISO认证</div>
            </div>
            <div class="modal-item">
              <img src="@/assets/v1/group5.png" alt="" class="modal-pic" />
              <div class="modal-desc">国家3A企业</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'choice',
  data() {
    return {}
  }
}
</script>
<style scoped>
.why-crm {
  padding-top: 100px;
  padding-bottom: 80px;
  background-color: #FAFBFC;
}
.why-desc {
  text-align: center;
  line-height: 24px;
}
.why-crm .why-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  padding-top: 70px;
  padding-bottom: 140px;
}
.why-main {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.top-content {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.why-bg {
  width: 100%;
}
.why-crm .why-wrap .why-wrap-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}
.why-crm .why-wrap .why-wrap-item .num {
  font-style: normal;
  color: #0252CC;
  font-weight: 700;
  font-size: 48px;
}
.right {
  border-right: 1px solid #EBECF0;
}
.bottom {
  border-bottom: 1px solid #EBECF0;
}
.modal-wrap {
  position: absolute;
  bottom: -60px;
  left: 0;
  width: 100%;
  background: #F8F9FB;
  box-shadow: 0px 2px 12px 0px #D7DBDF;
  border-radius: 3px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 30px;
  border: 4px solid #fff;
}
.modal-wrap .modal-item {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.modal-wrap .modal-item .modal-pic {
  width: 60px;
  height: 60px;
  display: block;
  margin-bottom: 10px;
  border-radius: 50%;
  background: #F8F9FB;
  border: 2px solid #FFFFFF;
  box-shadow: 0px 2px 6px #D7DBDF;
}
.btitle {
  font-size: 36px;
  line-height: 50px;
  color: #172B4D;
  text-align: center;
}
.stitle {
  text-align: center;
  font-size: 16px;
  color: #42526E;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/choice.vue